import { INTERVIEW_GUIDES } from '@/lib/betaConsole';

/** Semi-structured interview guides. Static: these are the questions that must be
 *  asked, not console state. Verbatim markers matter — paraphrasing a
 *  comprehension check destroys the thing it measures. */
export function InterviewsTab() {
  return (
    <>
      <section className="mb-13 rounded border border-border bg-surface p-13">
        <h2 className="mb-2 text-body font-semibold text-text-primary">Interview guides</h2>
        <p className="mb-2 text-body-sm text-text-secondary">
          Semi-structured. The questions below are the ones that must be asked; follow whatever the
          participant opens up. Record verbatim where marked — paraphrasing a comprehension check
          destroys the thing you are measuring.
        </p>
        <p className="text-body-sm text-text-muted">
          Every interview produces findings. Log them as you go, not from memory afterwards.
        </p>
      </section>

      {INTERVIEW_GUIDES.map((guide) => (
        <section key={guide.id} className="mb-13 rounded border border-border bg-surface p-13">
          <div className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-text-muted">{guide.when}</div>
          <h2 className="mb-3 text-body font-semibold text-text-primary">{guide.title}</h2>

          {guide.sections.map((section) => (
            <div key={section.heading} className="mb-3 last:mb-0">
              <h3 className="mb-1 text-body-sm font-semibold text-text-primary">{section.heading}</h3>
              <ul className="ml-4 list-disc text-body-sm text-text-secondary">
                {section.questions.map((q) => (
                  <li key={q.q} className="mb-1">
                    {q.q}
                    {q.note ? <span className="text-text-muted"> — {q.note}</span> : null}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {guide.footer ? (
            <div className="mt-3 rounded border-l-2 border-flagged bg-surface-sunken p-13">
              <p className="text-body-sm text-text-primary">{guide.footer}</p>
            </div>
          ) : null}
        </section>
      ))}
    </>
  );
}
